module.exports = __webpack_public_path__ + "img/arrow-up-left-from-circle.2c08ff51.svg";